import { useEffect, useState, useRef } from "react";

function CypherConsole({ tokenId, secretWord, dudeAction, layer1, layer2, layer3, bitEnvironment, bitPalette, lsb, gridSize, gridResolution, levelProgression, ownerAddy, message }) {

    function swapScripts2() {
        var script = document.getElementById("svgScript2");
        if (script != null) {
            let newScript = document.createElement("script");
            newScript.text = script.textContent;
            var cliNode = document.getElementById("CLI2")
            if (cliNode != null) {
                cliNode.after(newScript);
                script.remove();
            }
        }
    }

    useEffect(() => {
        document.getElementById('consoleSandBox').innerHTML = renderConsole(tokenId, secretWord, dudeAction, layer1, layer2, bitEnvironment, bitPalette, lsb, gridSize, gridResolution, levelProgression, ownerAddy, message);
        swapScripts2();
    })

    useEffect(() => {
        document.getElementById('consoleSandBox').innerHTML = renderConsole(tokenId, secretWord, dudeAction, layer1, layer2, bitEnvironment, bitPalette, lsb, gridSize, gridResolution, levelProgression, ownerAddy, message);
        swapScripts2();
    }, [tokenId, secretWord, dudeAction, layer1, layer2, bitEnvironment, bitPalette, lsb, gridSize, gridResolution, levelProgression, ownerAddy,])

    var seedrandom = require('seedrandom');

    const palettes = [{ values: { a: "#00ff00", b: "#ffffff", c: "#000000" }, names: { a: "green", b: "white", c: "black" } }, { values: { a: "#00ff00", b: "#000000", c: "#ffffff" }, names: { a: "green", b: "black", c: "white" } }, { values: { a: "#000000", b: "#00ff00", c: "#ffffff" }, names: { a: "black", b: "green", c: "white" } }, { values: { a: "#000000", b: "#00ff00", c: "#00ff00" }, names: { a: "black", b: "green", c: "green" } }, { values: { a: "#000000", b: "#ffffff", c: "#ffffff" }, names: { a: "black", b: "white", c: "white" } }, { values: { a: "#000000", b: "#ffffff", c: "#00ff00" }, names: { a: "black", b: "white", c: "green" } }, { values: { a: "#000000", b: "#ff00ff", c: "#00ffff" }, names: { a: "black", b: "fuschia", c: "aqua" } }, { values: { a: "#000000", b: "#ffffff", c: "#00ff00" }, names: { a: "black", b: "white", c: "green" } }, { values: { a: "#0000ff", b: "#ff0000", c: "#000000" }, names: { a: "blue", b: "red", c: "black" } }, { values: { a: "#000000", b: "#ff0000", c: "#ffff00" }, names: { a: "black", b: "red", c: "yellow" } }, { values: { a: "#0000ff", b: "#ffff00", c: "#ff00ff" }, names: { a: "blue", b: "yellow", c: "fuschia" } }, { values: { a: "#000000", b: "#ffffff", c: "#ffffff" }, names: { a: "black", b: "white", c: "white" } }]
    function cli(e) {
        return `<style>.hL{fill:#00ff00;}.fText{font-family:MonoPixel;padding-top:10px;font-size:10px;text-align: center;color:${e.values.a}}.tText{font-family:MonoPixel;font-size:18px;text-align: center;color:${e.values.a}}.h1Text{font-family:MonoPixel;font-size:14px;color:${e.values.a}}.h2Text{font-family:MonoPixel;font-size:10px;color:${e.values.a}}.pText{font-family:Andale Mono;width:360px;font-size:7px;color:${e.values.a}}.scroller {scrollbar-color: ${e.values.b === e.values.c ? "white" === e.names.b ? "#00ff00" : "#ffffff" : e.values.b} ${e.values.c}00;scrollbar-width: thin;overflow-y:auto;}.wPaper{height:320px;width: 100%;}.form{height:150px;border-left: 0.25px solid ${e.values.a};}.tabContentB1{padding: 5px 0px 0px 5px;display: none;height:320px;border-left: 0.25px solid ${e.values.a};}.tabContentB2{padding: 5px 0px 0px 5px;display: none;width: 365px;height:296px;border-left: 0.25px solid ${e.values.a};}.tabs{display: flex;}.tablinks_B1{width: 48%;}.tablinks_B2{width: 32%;}.tablinks_B1, .tablinks_B2{border: none;border-bottom: 0.25px solid ${e.values.a};background-color: transparent;display: inline-block;}.active{color: ${e.values.b === e.values.c ? "white" === e.names.b ? "#00ff00" : "#ffffff" : e.values.b};border: 0.25px solid ${e.values.a};border-bottom: none;}.input{font-family: 'Andale Mono';color: ${e.values.a};font-size: 7px;width: 100%;margin-right: 5px;border: 0.25px solid ${e.values.a};background-color: transparent;}.key{height:16px; margin-top:0px;}.input:active, .input:focus{outline: none !important;border: 0.5px solid ${e.values.a};box-shadow: 0 0 10px ${e.values.b === e.values.c ? "white" === e.names.b ? "#00ff00" : "#ffffff" : e.values.b};}textarea{scrollbar-color: ${e.values.b === e.values.c ? "white" === e.names.b ? "#00ff00" : "#ffffff" : e.values.b} ${e.values.c}00;scrollbar-width:thin; resize:none; overflow-y:auto; height: 215px;}.subBtn{border: 0.25px solid ${e.values.a};background-color: transparent;width: 30%;display: inline-block;}.subBtn:active{color: ${e.values.b === e.values.c ? "white" === e.names.b ? "#00ff00" : "#ffffff" : e.values.b};box-shadow: 0 0 10px ${e.values.b === e.values.c ? "white" === e.names.b ? "#00ff00" : "#ffffff" : e.values.b};}.cWp{display:flex;justify-content:space-between;}.cNt{width:auto;align-self:flex-end;}</style><defs><pattern id="pM" x="0" y="0" width="3" height="3" patternUnits="userSpaceOnUse" patternContentUnits="userSpaceOnUse"><circle id="pM" cx="0.5" cy="1" r="0.55" fill="#737373"></circle></pattern><pattern id="gL" x="0" y="0" width="1" height="1"><image height="10" width="10" image-rendering="pixelated" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAK0lEQVQ4jWNkYGD4z4AfMOKTZCKgmSAYNWAwGIA3jqEAbzoZeC+MGkAFAwAxXgIecmo1uAAAAABJRU5ErkJggg=="/></pattern><pattern id="gM" x="0" y="0" width="1" height="1"><image height="10" width="10" image-rendering="pixelated" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAL0lEQVQ4jWNkYGD4z4AKGNH4eOWZGCgEA28Aun8ZGEgMk4H3AlXCYDQdYIKRlg4ArA0IG+WyAAQAAAAASUVORK5CYII="/></pattern><pattern id="gS" x="0" y="0" width="1" height="1"><image height="10" width="10" image-rendering="pixelated" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAKklEQVQ4jWNgYGD4D8UwQBKfiYFCwIhmMrIYUXyKXQAzaTQMRsNgpIcBAJ3lL/GeFeu8AAAAAElFTkSuQmCC"/></pattern><pattern id="rL" x="0" y="0" width="1" height="1"><image height="10" width="10" image-rendering="pixelated" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAH0lEQVQ4jWNgGGjAiMT+T45eJkpdMGrAqAGDw4CBBwC2SwEYE2ukzgAAAABJRU5ErkJggg=="/></pattern><pattern id="rM" x="0" y="0" width="1" height="1"><image height="10" width="10" image-rendering="pixelated" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAIElEQVQ4jWNgGAUDDxiR2P9JUAsHTJS6YNSAwWDAwAMAmewBEMZQY3oAAAAASUVORK5CYII="/></pattern><pattern id="rS" x="0" y="0" width="1" height="1"><image height="10" width="10" image-rendering="pixelated" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAIElEQVQ4jWNgGAWjYDAARiT2fzxyOAETpS4YeAMGHgAAha0BCIq/fecAAAAASUVORK5CYII="/></pattern><pattern id="wL" x="0" y="0" width="1" height="1"><image height="10" width="10" image-rendering="pixelated" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAZElEQVQ4jcWSQQoAMQgDzdL/fzk9bRFN67qXCj0U4jABzW4Pwp+NrAaQmQGsWII8kgqs58jSsGuQ9oYyiOOhESYBb4ikqlEDfFAtfTbwEAD/DCqTrUHsv4McDar+Zr1TPu1dnAmiZDUW/UZ26gAAAABJRU5ErkJggg=="/></pattern><pattern id="off" x="0" y="0" width="1" height="1"><image height="10" width="34" image-rendering="pixelated" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAAQAgMAAAAg3mRlAAAADFBMVEVHcEz///8AAABsbGw6Bac1AAAAAXRSTlMAQObYZgAAAExJREFUCNdj+I8MPjAcYEABh1aBAMMqplUrgBTDyVAQaEDl7mJY1MCwgIFoLtC4Btxc7HpBrliJJrthFROEC3HkBxj3ANgrcI+g+ggATodZx0GeiegAAAAASUVORK5CYII="/></pattern><pattern id="on" x="0" y="0" width="1" height="1"><image height="10" width="34" image-rendering="pixelated" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAAQAgMAAAAg3mRlAAAADFBMVEVHcEwAAABsbGwA/wDKljyQAAAAAXRSTlMAQObYZgAAAEtJREFUCNdjWIUMFjA0MKCABoZQhgBWBtZQIAiBc+X/A8FfIJeVISAUxm3Axg0IxctlJY0rC3JGbAOqMxpQHBnWAPMCE9hHDGg+AgAsBFS7sgd6DQAAAABJRU5ErkJggg=="/></pattern><pattern id="cL" x="0" y="0" width="1" height="1"><image height="10" width="10" image-rendering="pixelated" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAANElEQVQ4jWNgoBL4D8Ukq2eilguIdQmGPNVdgMsmnC6jmQsI2kxzFwxcGAxcOhg8eYFkAADhwxn1yJnMrgAAAABJRU5ErkJggg=="/></pattern></defs>`
    }

    const p1 = [{
        p1Name: "Rare Pepes"
    }, {
        p1Name: "Cryptopunks"
    }, {
        p1Name: "Coin Flow"
    }, {
        p1Name: "Chart"
    }, {
        p1Name: "Moma Pixels"
    }, {
        p1Name: "PixelMon Reveal"
    }, {
        p1Name: "Crypto Space"
    }, {
        p1Name: "Crypto Voxel"
    }, {
        p1Name: "Circuit Board"
    }, {
        p1Name: "Uniswap"
    }, {
        p1Name: "Mooncats"
    }, {
        p1Name: "MaxPain"
    }];

    const p2 = [{
        p2Name: 'Gas Wars'
    }, {
        p2Name: 'PacMan'
    }, {
        p2Name: 'HardWare Wallet'
    }, {
        p2Name: 'Feels good man'
    }, {
        p2Name: 'Game Over'
    }, {
        p2Name: 'M3t4m4Sk'
    }, {
        p2Name: 'Promising Collab'
    }, {
        p2Name: 'MaxPain'
    }, {
        p2Name: 'Green Chart'
    }, {
        p2Name: 'Press that mint button'
    }, {
        p2Name: 'trashart'
    }, {
        p2Name: 'none'
    }]

    const p3 = [p1[0], p1[3], p1[4], p1[6], p1[7], p1[8], p1[9], p1[11], 'none'];
    function getDude(e, t, a) {
        return [{
            name: "Backdoor Dude"
        }, {
            name: "Bitruvian Dude"
        }, {
            name: "Building Dude"
        }, {
            name: "Dude scrolling"
        }, {
            name: "Fake Dude"
        }, {
            name: "Going to Zero Dude"
        }, {
            name: "Hashing Dude"
        }, {
            name: "Longterm Dude"
        }, {
            name: "Over minting Dude"
        }, {
            name: "Mooning Dude"
        }, {
            name: "Pumping Dude"
        }, {
            name: "Rabbit Hole Dude"
        }, {
            name: "Dude Regulatooors"
        }, {
            name: "Eyes on the Chart"
        }, {
            name: "Rugged Dude"
        }, {
            name: "Scammed Dude"
        }, {
            name: "Dude Walking By"
        }, {
            name: "Transfer Dude"
        }, {
            name: "Follow the Dude"
        }, {
            name: "Secret Dude"
        }][e]
    }

    function renderConsole(tokenId, secretWord, dudeAction, layer1, layer2, bitEnvironment, bitPalette, lsb, gridSize, gridResolution, levelProgression, ownerAddy, message) {
        function seededRandom(sd) {
            const rng = seedrandom(sd);
            return () => rng.quick();
        }
        const rngM = seededRandom(tokenId);
        let sd = [];
        for (let i = 0; i < 50; i++) {
            sd.push(rngM())
        };
        const palette = palettes[bitPalette];
        let svgCode = '<?xml version="1.0" encoding="utf-8" ?>';
        svgCode += `<div id="svg-container"><svg id="cypherdude" width="100%" baseProfile="full" viewBox="0 0 100 100" version="1.1" overflow="visible" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:ev="http://www.w3.org/2001/xml-events" xmlns:xlink="http://www.w3.org/1999/xlink" style="background-color:${palette.values.a}">`;
        // -- GRID -- //
        const _gridSize = gridSize === 128 ? 71 : gridSize === 64 ? 54 : gridSize;
        const mxSq = (levelProgression + 32) / 10;
        const sqrSR = (gridResolution + 1) / 10;
        const cellSize = 512 / _gridSize;
        const squares = [];
        const occupiedCells = new Array(_gridSize).fill().map(() => new Array(_gridSize).fill(false));
        for (let x = 0; x < _gridSize; x++) {
            for (let y = 0; y < _gridSize; y++) {
                if (!occupiedCells[x][y]) {
                    let maxSize = 1;
                    while (
                        x + maxSize < _gridSize &&
                        y + maxSize < _gridSize &&
                        !occupiedCells
                            .slice(x, x + maxSize + 1)
                            .some((row) => row.slice(y, y + maxSize + 1).some((cell) => cell))
                    ) {
                        maxSize++;
                    }

                    let useBigSquare = rngM() < sqrSR;
                    if (useBigSquare) {
                        maxSize = Math.min(Math.floor(rngM() * rngM() * ((mxSq + 1) - 2 + 1)) + 2, maxSize);
                    } else {
                        maxSize = Math.min(Math.floor(rngM() * rngM() * (2 - 1 + 1)) + 1, maxSize);
                    }
                    const rectSize = cellSize * maxSize;
                    const startColor = "#000000";
                    for (let i = x; i < x + rectSize / cellSize; i++) {
                        for (let j = y; j < y + rectSize / cellSize; j++) {
                            occupiedCells[i][j] = true;
                        }
                    }
                    squares.push({ color: startColor, height: rectSize, width: rectSize, x: x * cellSize, y: y * cellSize, opacity: 0, animated: false, orientation: {}, });
                }
            }
        }
        
        var bkgName = '';
        switch (bitEnvironment) {
            case 0:
                bkgName += '32 bits';
                break;
            case 1:
                bkgName += '32 bits animated';
                break;
            case 2:
                bkgName += '64 bits';
                break;
            case 3:
                bkgName += '64 bits animated';
                break;
            case 4:
                bkgName += 'Who dis ?';
                break;
            case 5:
                bkgName += 'Bitcoin genesis block';
                break;
            case 6:
                bkgName += 'Data tunnel';
                break;
            case 7:
                bkgName += 'Meta script';
                break;
            case 8:
                bkgName += 'The Cypherpunk';
                break;
            default:
                break;
        }

        let hasLayer2 = p2[layer2].p2Name != "none";
        let layer2_ = hasLayer2 ? p2[layer2] : '';
        let hasLayer3 = p3[layer3] != "none";
        const dude = getDude(dudeAction, palette, hasLayer3 ? p3[layer3].p1Pat : '');

        // -- DISPLAY -- //
        let chCnt = (Math.floor(((squares.length * 8) - 450) / 64) * 32 + 32).toLocaleString(undefined, { minimumFractionDigits: 0 });
        svgCode += `<svg id="CLI2" x="0" y="0" viewbox="0 0 100 100" width="100" height="100">` + cli(palette) + `<rect x="0" y="0" width="100" height="100" stroke="#000000" stroke-width="0.5" fill="#ffffff99"></rect><rect id="G_f" alt1="CURRENT GRID SIZE :" alt2="${gridSize} squares side" class="ico" x="2" y="2" width="10" height="10" stroke="#000000" stroke-width="0.5" fill="#ffffff"></rect><rect  x="2" y="2" width="10" height="10" fill="url(${gridSize === 32 ? '#gL' : gridSize === 64 ? '#gM' : '#gS'})" pointer-events="none"></rect><rect id="R_f" alt1="CURRENT RESOLUTION :" alt2="${sqrSR === 0.3 ? 'Low' : sqrSR === 0.2 ? 'Medium' : 'High'}" class="ico" x="14" y="2" width="10" height="10" stroke="#000000" stroke-width="0.5" fill="#ffffff"></rect><rect x="14" y="2"  width="10" height="10" fill="url(${sqrSR === 0.1 ? '#rS' : sqrSR === 0.2 ? '#rM' : '#rL'})" pointer-events="none"></rect><rect id="W_f" alt1="WHITEPAPER - ENCRYPTION :" alt2="Click to open the" alt3="smart-contract interface." class="ico" cursor="pointer" onclick="o_pen()" x="26" y="2" width="10" height="10" stroke="#000000" stroke-width="0.5" fill="#ffffff"></rect><rect x="26" y="2"  width="10" height="10" fill="url(#wL)" pointer-events="none"></rect><rect id="s_f" alt1="Switch :" alt2="Play / Pause the animation" class="ico" cursor="pointer" onclick="s_witch(evt)" x="64" y="2" width="34" height="10" stroke="#000000" stroke-width="0.5" fill="#ffffff"></rect><rect id="s_p2" x="64" y="2"  width="34" height="10" fill="url(#on)" pointer-events="none"></rect><rect class="draggable" cursor="move" x="38" y="2"  width="24" height="10" fill="url(#pM)"></rect><rect x="2" y="14" width="96" height="84" fill="#000000E6" stroke="#002030CC"></rect><defs><clipPath id="display"><rect x="2" y="50" width="96" height="48" fill="none"></rect></clipPath></defs><text y="4" fill="#00ff00" font-family="MonoPixel" font-size="7" ><tspan x="24" dy="15">┌─────────────┐</tspan><tspan x="27" dy="3">${getProg(levelProgression, 1, 32, true)}</tspan><tspan class="ico" alt1="LEVEL PROGRESSION" alt2="Currently ${levelProgression} steps away" alt3="from next level." x="4" dy="0">LXP:</tspan><tspan x="24" dy="4">└─────────────┘</tspan><tspan x="24" dy="2">┌─────────────┐</tspan><tspan x="27" dy="3">${getProg(squares.length, 80, 10000, false)}</tspan><tspan class="ico" alt1="GLOBAL PROGRESSION" alt2="Current state relative" alt3="to the whole collection." x="4" dy="0">GXP:</tspan><tspan x="24" dy="4">└─────────────┘</tspan><tspan class="ico" alt1="Defines the maximum length" alt2="of the encrypted message." x="4" dy="8">${chCnt} characters available</tspan><tspan x="4" dy="9">·····················································</tspan></text><text y="50" fill="#00ff00" font-family="MonoPixel" font-size="7" clip-path="url(#display)"><tspan x="4" dy="15">--------CYPHERDUDES--------</tspan><tspan x="4" dy="7">---------------------------</tspan><tspan x="4" dy="7">-----------` + `\\` + `-[*]-----------</tspan><tspan x="4" dy="7">------------'F/` + `\\` + `-----------</tspan><tspan x="4" dy="7">-------------3;-` + `\\` + `----------</tspan><tspan x="4" dy="7">------------/-|------------</tspan><tspan x="4" dy="7">-----------/--|------------</tspan><tspan x="4" dy="7">---------------------------</tspan><tspan x="4" dy="7">-----------#${tokenId.toString().padStart(4, '0')}-----------</tspan><tspan x="4" dy="20">Action  :</tspan><tspan x="4" dy="8">- ${dude.name}</tspan><tspan x="4" dy="10">Layer 1:</tspan><tspan x="4" dy="8">- ${p1[layer1].p1Name}</tspan><tspan x="4" dy="10">Layer 2:</tspan><tspan x="4" dy="8">- ${hasLayer2 ? layer2_.p2Name : 'none'}</tspan><tspan x="4" dy="10">Layer 3:</tspan><tspan x="4" dy="8">- ${layer3 === 8 ? 'none' : p3[layer3].p1Name}</tspan><tspan x="4" dy="10">Secret Word :</tspan><tspan x="4" dy="8">- ${secretWord.toUpperCase()}</tspan><tspan x="4" dy="10">Bit Environment :</tspan><tspan x="4" dy="8">- ${bkgName}</tspan><tspan x="4" dy="10">Bit Palette :</tspan><tspan x="4" dy="8">- ${palette.names.a + " / " + palette.names.b + " / " + palette.names.c}</tspan><tspan x="4" dy="15">--------CYPHERDUDES--------</tspan><tspan x="4" dy="7">---------------------------</tspan><tspan x="4" dy="7">-----------` + `\\` + `-[*]-----------</tspan><tspan x="4" dy="7">------------'F/` + `\\` + `-----------</tspan><tspan x="4" dy="7">-------------3;-` + `\\` + `----------</tspan><tspan x="4" dy="7">------------/-|------------</tspan><tspan x="4" dy="7">-----------/--|------------</tspan><tspan x="4" dy="7">---------------------------</tspan><tspan x="4" dy="7">-----------#${tokenId.toString().padStart(4, '0')}-----------</tspan><animate attributeName="y" values="50;-157" dur="10s" repeatCount="indefinite"/></text><rect id="tmp_D2" x="2" y="50" width="96" height="48" fill="#000000E6" style="display:none;"></rect><text id="tmp_ta" y="50" fill="#00ff00" font-family="MonoPixel" font-size="7"><tspan id="tmp_ta1" x="4" dy="15"></tspan><tspan id="tmp_ta2" x="4" dy="10"></tspan><tspan id="tmp_ta3" x="4" dy="7"></tspan></text></svg>`;

        // -- DISPLAY SCRIPT -- //
        svgCode += `<script id="svgScript2" type="text/javascript"> <![CDATA[
            var icos = document.getElementsByClassName('ico');
            for (var i = 0; i < icos.length; i++) {
                icos[i].addEventListener('mouseover', mouseOverEffect);
                icos[i].addEventListener('mouseout', mouseOutEffect);
            }
            function mouseOverEffect() {
                this.classList.add("hL");
                document.getElementById('tmp_D2').style.display = "block";
                document.getElementById('tmp_ta').style.display = "block";
                document.getElementById('tmp_ta1').innerHTML = this.getAttribute('alt1');
                document.getElementById('tmp_ta2').innerHTML = this.getAttribute('alt2');
                document.getElementById('tmp_ta3').innerHTML = this.getAttribute('alt3');
            }
            function mouseOutEffect() {
                this.classList.remove("hL");
                document.getElementById('tmp_D2').style.display = "none";
                document.getElementById('tmp_ta').style.display = "none";
            }
            var s_witch = function(evt) {
                var f = document.getElementById('s_p2').getAttribute('fill');
                if (f === 'url(#off)') {
                    document.getElementById('s_p2').setAttribute('fill', 'url(#on)');
                    document.getElementById('cypherdude').unpauseAnimations();
                } else {
                    document.getElementById('s_p2').setAttribute('fill', 'url(#off)');
                    document.getElementById('cypherdude').pauseAnimations();
                }
            }
            var c_lose = function(evt) {
                document.getElementById('doc').style.display = "none";
            }
            var o_pen = function(evt) {
                document.getElementById('doc').style.display = "block";
            }
            function sendDecode(){
                var decodeEvent = new Event('decode');
                window.parent.dispatchEvent(decodeEvent);
            }
            function sendEncode(){
                var encodeEvent = new Event('encode');
                window.parent.dispatchEvent(encodeEvent);
            }
            function sendLSB(){
                var lsbEvent = new Event('lsb');
                window.parent.dispatchEvent(lsbEvent);
            }
            function sendPublic(){
                var publicArchiveEvent = new Event('publicArchive');
                window.parent.dispatchEvent(publicArchiveEvent);
            }
            function sendPrivate(){
                var privateArchiveEvent = new Event('privateArchive');
                window.parent.dispatchEvent(privateArchiveEvent);
            }
            if (document.getElementById('clock')) {
                var cvs = document.querySelector('#clock').innerHTML;
            
                function clock() {
                    if (document.getElementById('clock')){
                        document.querySelector('#clock').innerHTML = Date.now();
                        setTimeout(clock, 1);
                    }
                }
                clock();
            }
               ]]>
          </script>`;
        svgCode += `</svg></div>`;
        return svgCode;
    }

    function maptoRange(t, e, a, n, r) {
        return (t - e) * (r - n) / (a - e) + n
    }
    function getProg(t, e, a, n) {
        var r = (n ? 17 : 0) + maptoRange(t, e, a, 1, 16) * (n ? -1 : 1), d = ""; for (let t = 0; t < Math.floor(r); t++)d += "■"; return d
    }
    function dumpBin(t, e, a) {
        var n = ""; for (let r = 0; r < a; r++)n += `${a > 1 ? " " : ""}${t[e]}`;
        return n
    }
}
export default CypherConsole;